module.exports = __webpack_public_path__ + "static/img/project3.18f19f6c.png";